import actions from "./proactive-chat-actions";

const proactiveChatOperations = {
    ...actions,
};
export default proactiveChatOperations;
